import styled, { css } from 'styled-components';

import { Link } from 'components/Link';
import { colors } from 'theme/theme';

const sharedItemCss = css`
  display: inline-flex;
  position: relative;
  font-size: 16px;
  font-weight: normal;
  color: ${colors.lightContentGrey};
`;

export const PageFooterLanguageLinksLink = styled(Link)`
  ${sharedItemCss};
`;

export const PageFooterLanguageLinksDisabledText = styled.div`
  opacity: 0.5;
  cursor: auto;
  ${sharedItemCss};
`;
